import {
  call,
  all,
  select,
  put,
  takeLatest,
  take,
  fork,
  race
} from "redux-saga/effects"
import {
  actionTypes,
  selectors
} from "./location"
import {
  getCurrentPosition,
  fetchGeoDataFromPosition,
  fetchGeoDataFromPostcode
} from "../../apis/geo"
import {
  persist
} from "../../apis/persist"
import gtmHandler from "AtomicUtils/gtmHandler"
import { dispatchEvent, createNewEvent } from 'AtomicUtils/newEvent'

const {
  LOCATION_FETCH_START,
  LOCATION_FETCH_SUCCESS,
  LOCATION_FETCH_ERROR,
  LOCATION_FETCH_REQUEST,
  UPDATE_POSTCODE_REQUEST,
  UPDATE_POSTCODE_SUCCESS,
  POSTCODE_INPUT_REQUEST,
  POSTCODE_INPUT_CANCEL,
  POSTCODE_POPUP_SHOW,
  POSTCODE_POPUP_HIDE,
  LOCATION_CONFIRMED
} = actionTypes

function* updatePostcode({
  payload
}) {
  yield put({
    type: LOCATION_FETCH_START
  })

  try {
    const {
      state,
      locality,
      postcode: newPostcode
    } = yield call(fetchGeoDataFromPostcode, payload.postcode)

    persist({
      postcode: newPostcode,
      state,
      locality,
      localDealer: ""
    })

    yield put({
      type: UPDATE_POSTCODE_SUCCESS
    })
    yield put({
      type: LOCATION_FETCH_SUCCESS,
      payload: {
        state,
        locality,
        postcode: newPostcode
      }
    })
    // Fire a GTM action
    setTimeout(() => {
      gtmHandler({
        pageCategory: "Postcode Pop-up",
        pageAction: `Postcode Pop-up - Entered "${newPostcode}"`
      })
    }, 100)
    // Fire an action to update price ( gradepicker )
    setTimeout(() => {
      let event = createNewEvent("POSTCODE_UPDATE")
      dispatchEvent(event)
    }, 100)
  } catch (error) {
    console.warn(error)
    yield put({
      type: LOCATION_FETCH_ERROR,
      payload: {
        error
      }
    })
  }
}

function* fetchLocation() {
  let {
    latitude,
    longitude
  } = yield select(selectors.getLocation)

  try {
    // 'NaN' as a string will come out as truthy, so we cast for this check
    if (!(Number(latitude) && Number(longitude))) {
      const {
        coords
      } = yield getCurrentPosition()
      latitude = coords.latitude
      longitude = coords.longitude
    }

    persist({
      latitude,
      longitude
    })

    yield put({
      type: LOCATION_FETCH_START
    })

    const {
      postcode,
      locality,
      state
    } = yield call(fetchGeoDataFromPosition, {
      latitude,
      longitude
    })
    persist({
      postcode,
      state,
      locality,
      localDealer: ""
    })

    const {
      locationConfirmed
    } = yield select(selectors.getLocation)

    yield put({
      type: LOCATION_FETCH_SUCCESS,
      payload: {
        state,
        locality,
        postcode
      }
    })
  } catch (error) {
    yield put({
      type: LOCATION_FETCH_ERROR,
      payload: {
        error
      }
    })
  }
}

function* requestPostcodeInput() {
  const {
    postcodePopupOpen
  } = yield select(selectors.getLocation)

  if (!postcodePopupOpen) {
    yield put({
      type: POSTCODE_POPUP_SHOW
    })

    const {
      gotPostcode,
      closed
    } = yield race({
      gotPostcode: take(UPDATE_POSTCODE_SUCCESS),
      closed: take(POSTCODE_POPUP_HIDE)
    })

    if (gotPostcode || closed) {
      persist({
        locationConfirmed: true
      })
      yield put({
        type: LOCATION_CONFIRMED
      })
      if (!closed) yield put({
        type: POSTCODE_POPUP_HIDE
      })
    }
  }
}

function* cancelPostcodeInput() {
  yield put({
    type: POSTCODE_POPUP_HIDE
  })
}

export default function* () {
  yield all([
    fork(function* () {
      yield takeLatest(LOCATION_FETCH_REQUEST, fetchLocation)
    }),
    fork(function* () {
      yield takeLatest(UPDATE_POSTCODE_REQUEST, updatePostcode)
    }),
    fork(function* () {
      yield takeLatest(POSTCODE_INPUT_REQUEST, requestPostcodeInput)
    }),
    fork(function* () {
      yield takeLatest(POSTCODE_INPUT_CANCEL, cancelPostcodeInput)
    })
  ])
}



// WEBPACK FOOTER //
// ./src/store/actions/location-async.js